/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LicenseFeatureRepresentation } from './LicenseFeatureRepresentation';
import {
    LicenseFeatureRepresentationFromJSON,
    LicenseFeatureRepresentationFromJSONTyped,
    LicenseFeatureRepresentationToJSON,
    LicenseFeatureRepresentationToJSONTyped,
} from './LicenseFeatureRepresentation';

/**
 * 
 * @export
 * @interface LicenseRepresentation
 */
export interface LicenseRepresentation {
    /**
     * 
     * @type {string}
     * @memberof LicenseRepresentation
     */
    key: string;
    /**
     * 
     * @type {Array<LicenseFeatureRepresentation>}
     * @memberof LicenseRepresentation
     */
    features: Array<LicenseFeatureRepresentation>;
}

/**
 * Check if a given object implements the LicenseRepresentation interface.
 */
export function instanceOfLicenseRepresentation(value: object): value is LicenseRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('features' in value) || value['features'] === undefined) return false;
    return true;
}

export function LicenseRepresentationFromJSON(json: any): LicenseRepresentation {
    return LicenseRepresentationFromJSONTyped(json, false);
}

export function LicenseRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): LicenseRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'features': ((json['features'] as Array<any>).map(LicenseFeatureRepresentationFromJSON)),
    };
}

export function LicenseRepresentationToJSON(json: any): LicenseRepresentation {
    return LicenseRepresentationToJSONTyped(json, false);
}

export function LicenseRepresentationToJSONTyped(value?: LicenseRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'features': ((value['features'] as Array<any>).map(LicenseFeatureRepresentationToJSON)),
    };
}

